import React, { Fragment } from 'react';
import PropTypes from 'prop-types'
import '../OfficesPage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';
import Skeleton from '../../../components/library/loaders/Skeleton';
import Breadcrumb from '../../../components/common/Breadcrumb/Breadcrumb';

const OfficesPageHeader = ({ officeId, officeSummary }) => {

    return (
        <Fragment>
            <div className='columns'>
                <div className='ml-5 mb-5' >
                    <Breadcrumb
                        paths={[
                            { href: '/', label: <HrbTranslate text='Breadcrumbs.HomePage' /> },
                            { href: `/offices/${officeId}`, label: <HrbTranslate text='Breadcrumbs.OfficesPage' params={{ OfficeId: officeId }} /> }
                        ]}
                    />
                </div>
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1 homePageHeader' >
                    <h1 className='page-title'>
                        {officeSummary && officeSummary.title &&
                            <HrbTranslate text='OfficesPage.Labels.Title' params={{ OfficeId: officeId, Title: officeSummary.title }} />
                        }
                        {(!officeSummary || !officeSummary.title) &&
                            <Skeleton width='450px' />
                        }
                    </h1>
                </div>
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1 homePageHeader' >
                    {officeSummary && officeSummary.address && officeSummary.phone &&
                        <Fragment>
                            <HrbTranslate text='OfficesPage.Labels.Address' params={{ Address: officeSummary.address }} />
                            <br/>
                            <HrbTranslate text='OfficesPage.Labels.Phone' params={{ Phone: officeSummary.phone }} />
                        </Fragment>
                    }
                    {(!officeSummary || !officeSummary.address || !officeSummary.phone) &&
                        <Fragment>
                            <Skeleton width='300px' />
                            <Skeleton width='200px' />
                        </Fragment>
                    }
                </div>
            </div>
        </Fragment>
    )
}

OfficesPageHeader.propTypes = {
    officeId: PropTypes.number,
    officeSummary: PropTypes.object
}

export default OfficesPageHeader